/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

// search screen

export const PRICE_LEVEL_SEARCH_INPUT_DATA = 'PRICE_LEVEL_SEARCH_INPUT_DATA';
export const PRICE_LEVEL_ERRORS = 'PRICE_LEVEL_ERRORS';
export const PRICE_LEVEL_MANUFACTURER_GRID = 'PRICE_LEVEL_MANUFACTURER_GRID';
export const GET_PRICE_LEVEL_QTR = 'GET_PRICE_LEVEL_QTR';
export const PRICE_LEVEL_DRUG_FAMILY = 'PRICE_LEVEL_DRUG_FAMILY';
export const GET_PLAN_TYPE_DESC = 'GET_PLAN_TYPE_DESC';

// details screen
export const PRICE_DETAILS_INPUT_DATA = 'PRICE_DETAILS_INPUT_DATA';
export const PRICE_DETAIL_ERRORS = 'PRICE_DETAIL_ERRORS';
export const REBATE_PRICE_LEVEL_DETAILS_API = 'REBATE_PRICE_LEVEL_DETAILS_API';
export const STORE_REBATE_PRICE_DETAILS = 'STORE_REBATE_PRICE_DETAILS';
export const PRICE_DETAILS_GRIDS = 'PRICE_DETAILS_GRIDS';
export const SAVE_GRID_TWO = 'SAVE_GRID_TWO'
export const STORE_UPDATED_PAGE = 'STORE_UPDATED_PAGE'
export const STORE_BLUR_STATE = 'STORE_BLUR_STATE'
export const STORE_OVERLAP_STATE_ERR = 'STORE_OVERLAP_STATE_ERR'
export const STORE_PRICE_LEVEL_ALL_LIST = 'STORE_PRICE_LEVEL_ALL_LIST'
